const appendTasks = (tasks) => {
  const updatedTasks = tasks.split("\n").map((task) => task.trim());
  console.log(updatedTasks);
  return updatedTasks;
};

const parseText = (text) => {
    const splitText = text.split(/(Description:|Tasks:|Notes:)/);
    const description = splitText[2]?.trim();
    const tasks = appendTasks(splitText[4]?.trim());
    const notes = splitText[6]?.trim();

    return { description, tasks, notes };
};

const separateListItems = (text) => {
  const listItems = text.split("\n\n").filter((item) => item !== "");
  return listItems;
};

const difficultyLevels = {
    "very, very easy": [0, 7],
    easy: [8, 11],
    medium: [12, 14],
    hard: [15, Infinity],
};

const determineDifficulty = (age) => {
    for (let level in difficultyLevels) {
        if (
        age >= difficultyLevels[level][0] &&
        age <= difficultyLevels[level][1]
        ) {
        return level;
        }
    }
};

export { parseText, separateListItems, determineDifficulty };